import React, { Component } from 'react';
import './RoomList.css';

import RoomListCell from './RoomListCell.js';
import RoomSettingsModal from './RoomSettingsModal.js';

class RoomList extends Component {
  constructor(props) {
    super(props);
    this.renderCell = this.renderCell.bind(this);

    this.state = {
      roomSettings: null
    };
  }

  /**
   * Open the room settings modal for a given room.
   *
   * @param {Object} room The room to open the modal for.
   * @param {String} room.id The ID of the room.
   * @memberof RoomList
   */
  openRoomSettings = (room) => {
    // Cache the room ID we want to modify. We do this so if we get new information
    // in the Redux store about the room, it'll be updated automatically, as we're
    // not caching the room object here but instead fetching it from the list of rooms in
    // the store each time we render the settings modal.
    //
    // (See: the render() hook where roomSettingsModal is instantiated).
    this.setState({ roomSettings: room.id });
  }

  /**
   * Clear out the room settings ID to close the modal.
   *
   * @memberof RoomList
   */
  closeRoomSettings = () => {
    this.setState({ roomSettings: null });
  }

  /**
   * Render a cell for a given room.
   *
   * @param {Object} room The room to render a cell for.
   * @param {String} room.id The GUID of the room.
   * @param {String} room.name The name of the room.
   * @param {Date} room.lastJoined The date the user last joined the room.
   * @param {Object[]} room.friends The list of users friends that are in the room.
   * @returns {JSX} The JSX for the cell.
   * @memberof RoomList
   */
  renderCell(room) {
    return <RoomListCell key={room.id} room={room} onClick={() => this.props.onRoomClick(room)} openRoomSettings={this.openRoomSettings} />
  }

  render() {
    let { roomSettings } = this.state;
    let { className, currentUser, rooms } = this.props;
    rooms = rooms || []; // fall back to an empty array if `this.props.rooms` is falsy

    let roomCells = rooms.map(this.renderCell);

    if (!roomCells.length) {
      roomCells = <p className="text-help text-help--light">You don't have any rooms just yet. Click "Start a new room" above to create one!</p>;
    }

    let roomSettingsModal;
    if (roomSettings) {
      // Grab the room to modify from the list of rooms, and pass it into the settings modal.
      let room = rooms.filter((r) => r.id === roomSettings)[0];
      roomSettingsModal = (
        <RoomSettingsModal
          room={room}
          currentUser={currentUser}
          openInviteFlow={this.props.openInviteFlow}
          close={this.closeRoomSettings} />
      );
    }

    let listClassNames = ['RoomList'];
    if (className) {
      listClassNames.push(className);
    }

    return (
      <section className={listClassNames.join(' ')}>
        {roomSettingsModal}
        {roomCells}
      </section>
    );
  }
};

export default RoomList;



// WEBPACK FOOTER //
// ./src/components/RoomList.js